// extracted by mini-css-extract-plugin
module.exports = {"events_table":"style_events_table_2Vbh_","time_formatted":"style_time_formatted_1xXM5"};